import React, {useEffect, useContext} from "react"
import { Collapse, Row } from "reactstrap"
import MobileTableUI from "./MobileTableUI"
import MobileOverall from "./MobileOverall"
import ReportButtonProject from "pages/Reports/VerifyMyTeams/ActionButton/ReportButtonProject"
import CustomAccordianHeader from "./CustomAccordianHeader"
import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom/cjs/react-router-dom.min"
import { MyContext } from "../../../pages/Reports/VerifyMyTeams/index"

const Accordian = props => {
  const { item, itemProject, sethandleAccordion, handleAccordion, keyId } = props

  const { pathname } = useLocation();

  const handleOnclickAccordion = value => {
    if (handleAccordion === value) {
      sethandleAccordion(null)
    } else {
      sethandleAccordion(value)
    }
  }

  const {
    handleOnExpand,
    handleVerify,
  } = props;
  const {
    onClickSubmitButton,
    setSelectedArrayLists,
    selectedArrayLists,
    selectToggleTeam,
    ExcludeNonReportFunction,
    noRowsSelected,
    isDateLessThanCurrent,
    onClickQuickSendToClient,
    isMobileTeam
  } = useContext(MyContext) || {};
  const {
    accessgroupname,
    compactView
  } = useSelector(state => ({
    accessgroupname: state?.Login?.usersDetails?.data,
  }))
  
  let getUnVerifiedLists = (item[keyId]?.timeSheetReports || []).filter(
    el =>
      el?.workReportSummary?.projectSummaryList[0]?.tasks[0]?.screenExist &&
      el?.workReportSummary?.projectSummaryList[0]?.tasks[0]?.screenVerified ===
        false
  )
  const getUnVerifiedErrorLists = (getUnVerifiedLists || []).filter(item =>
    (selectedArrayLists || []).some(ele => ele?.userId === item?.userId)
  )

  const filterVerifiedLists = (item[keyId]?.timeSheetReports || []).filter(
    el =>
      el?.workReportSummary?.projectSummaryList[0]?.tasks[0]?.screenVerified ||
      !el?.workReportSummary?.projectSummaryList[0]?.tasks[0]?.screenExist
  )
  let getUnSubmittedLists = (filterVerifiedLists || []).filter(
    el =>
      el?.workReportSummary?.projectSummaryList[0]?.tasks[0]?.workReportId === 0
  )

  const getOnEvaluationErrorList = (
    item[keyId]?.timeSheetReports || []
  )?.filter(el => el?.onEvaluationHours !== "00:00:00")

  useEffect(() => {
    if (handleAccordion === keyId && pathname === "/verifyscreenTeams") {
      setSelectedArrayLists(item[keyId]?.timeSheetReports)
    }
  }, [handleAccordion === keyId, pathname])

  return (
    <React.Fragment>
      <Row>
        <div className="accordion table-align-mobile" id="accordion" key={keyId}>
          <div className="accordion-item mb-2">
            <CustomAccordianHeader
              handleAccordion={handleAccordion}
              keyId={keyId}
              title={itemProject}
              onClick={handleOnclickAccordion}
            />
            <Collapse
              isOpen={handleAccordion === keyId}
              className="accordion-collapse"
            >
              <div className="accordion-body">
                <div className="text-muted">
                  {(pathname === "/verifyscreenTeams" && !selectToggleTeam) && (
                    <MobileOverall data={item[keyId]} id={keyId} compactView={compactView}/>
                  )}
                    <MobileTableUI
                    itemdata={pathname === "/verifyscreen" ? item : (!selectToggleTeam ? item?.map(el => el?.timeSheetReports) : item?.map(el => el?.projectTimeSheet))}
                    selectedArrayLists={selectedArrayLists}
                    id={keyId}
                    handleOnExpand={handleOnExpand}
                    handleVerify={handleVerify}
                  />
                  <div>
                    {(pathname === "/verifyscreenTeams" && !selectToggleTeam) && (
                      <ReportButtonProject
                        onClickSubmitButton={onClickSubmitButton}
                        getErrorListsUnSubmitted={getUnSubmittedLists}
                        getOnEvaluationErrorList={getOnEvaluationErrorList}
                        accessgroupname={accessgroupname}
                        ExcludeNonReportFunction={ExcludeNonReportFunction}
                        selectedArrayLists={selectedArrayLists}
                        getUnVerifiedErrorLists={getUnVerifiedErrorLists}
                        noRowsSelected={noRowsSelected}
                        list={item[keyId]?.timeSheetReports}
                        splittedStatusName={
                          item[keyId]?.workReportStatusName?.[0]
                        }
                        isMobile={isMobileTeam}
                        isDateLessThanCurrent={isDateLessThanCurrent}
                        onClickQuickSendToClient={onClickQuickSendToClient}
                        setSelectedArrayLists={setSelectedArrayLists}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </Row>
    </React.Fragment>
  )
}

export default Accordian
